export default "__VITE_ASSET__CO3IEZga__"